/* Reviews page: photo rail arrows and the per-review story dialogs (sections/reviews-page.liquid). */
(function () {
  var root = document.querySelector('[data-rv]');
  if (!root) return;
  var rail = root.querySelector('[data-rv-rail]');

  root.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-rv-scroll]');
    if (arrow && rail) {
      var dir = Number(arrow.getAttribute('data-rv-scroll')) || 1;
      rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var tile = e.target.closest('[data-rv-open]');
    if (tile) {
      var dialog = document.getElementById(tile.getAttribute('data-rv-open'));
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      return;
    }
  });

  /* A click on the dimmed backdrop lands on the dialog element itself; close it. */
  root.querySelectorAll('.rv-dialog').forEach(function (dialog) {
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog && typeof dialog.close === 'function') dialog.close();
    });
  });
})();
